// extracted by mini-css-extract-plugin
export default {"container":"FullscreenSpinner-module_container_ye1P4v"};